module.exports = __webpack_public_path__ + "static/media/3_col_6.4c41ffbf.jpg";